import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { List, Map } from 'immutable';

import { EditableSection } from '®shared/reading-list/models';

import { ContainedTypeAndId, containerKey } from '../state';

const ODD = 'nest-level--odd';
const EVEN = 'nest-level--even';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'rl-view-container-node',
  templateUrl: './view-container-node.component.html',
})
export class ViewContainerNodeComponent implements OnChanges {
  @Input() containerStructure: Map<string, List<ContainedTypeAndId>>;
  @Input() depth = 0;
  @Input() entry: ContainedTypeAndId;
  @Input() entryVisibility: Map<string, boolean> | null;
  @Input() sectionsById: Map<string, EditableSection>;

  classes: string;
  containerChildren: List<ContainedTypeAndId>;

  isHidden: boolean;

  ngOnChanges() {
    this.classes = this.depth % 2 === 1 ? ODD : EVEN;
    this.containerChildren = this.containerStructure.get(
      containerKey(this.entry),
    );
    this.isHidden = this.entryVisibility
      ? this.entryVisibility.get(containerKey(this.entry)) === false
      : false;
  }
}
